module.exports = __webpack_public_path__ + "static/media/DCLogo.619bb961.png";